define((require) => {
    "use strict";

    const LinkAction         = require("shared/ui/experience/action/link/LinkAction");
    const ParametersHelper   = require("shared/ui/experience/action/ParametersHelper");
    const ProductActionMixin = require("shared/ui/experience/action/product/ProductActionMixin");

    /**
     * Open a product via a link.
     *
     * @class ProductLinkAction
     * @constructor
     */
    return LinkAction.extend("ProductLinkAction", {

        mixin: ProductActionMixin,

        _url() { // TODO: ensure editor sets the "url" always instead, no need to marshall all this
            return this.get("url") || ParametersHelper.inject(this.get("urlTemplate"), this.get("parameters"));
        }

    }, {
        TYPE: "productLink"
    });
});



// WEBPACK FOOTER //
// ./src/shared/ui/experience/action/product/ProductLinkAction.js